import { firestoreConverter } from "@/domain/core/converters/client_firestore_converter"

export interface AppConfig {
  androidForceUpdate: Version
  iosForceUpdate: Version
  kanrilGuide: KanrilGuide
  privacyPolicyUrl: string
  termsOfUseUrl: string
}

export interface Version {
  forcedVersion: string
  recommendedVersion: string
}

export interface KanrilGuide {
  baseTimeUrl: string
  holidayWorkUrl: string
  midnightSurchargeUrl: string
  overtimeUrl: string
  prevOfMissedPunctureUrl: string
  startGuideUrl: string
  suggestionBoxUrl: string
  overtimePermissionSystemUrl: string
  roundingUrl: string
}

export namespace AppConfig {
  export namespace firestore {
    export const clientConverter = firestoreConverter<AppConfig>()

    export const documentPath = () => `AppConfig/v2/appConfig/doc`
  }
}
